module.exports = __webpack_public_path__ + "static/img/xint_en.1e5b957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/xint_en.jpg
// module id = JmiJ
// module chunks = 0